import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useActiveProject } from '../../context/ActiveProjectContext';
import {
  isStaffPathAllowedWithoutProject,
  parseProjectIdFromPath,
} from '../../utils/deepLink';

/**
 * Staff can browse org routes without a project; nested /app/projects/:id/* syncs active project.
 */
export default function StaffProjectGate({ children }) {
  const location = useLocation();
  const { activeProjectId, setActiveProject, loading } = useActiveProject();
  const routeProjectId = parseProjectIdFromPath(location.pathname);

  useEffect(() => {
    if (routeProjectId && routeProjectId !== activeProjectId) {
      setActiveProject(routeProjectId);
    }
  }, [routeProjectId, activeProjectId, setActiveProject]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isStaffPathAllowedWithoutProject(location.pathname)) {
    return children;
  }

  if (routeProjectId) {
    return children;
  }

  return <Navigate to="/app/projects" replace />;
}
